'use client'
import React, { useState } from 'react'
import { FaLine } from 'react-icons/fa'
import { MdPhoneIphone } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import tailwindConfig from '@tailwind.config'
import { company } from '@constants/company';
// import ContactCardProject from '@components/ContactCardProject';
import dynamic from "next/dynamic";

const ContactCardProject = dynamic(
    () => import("@components/ContactCardProject"),
    { ssr: false }
);

const ProjectContact = ({ project, agent, dictionary, lang }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openEnquiry = (e) => {
        setIsOpen(!isOpen)
    };

    return (
        <>  
            {isOpen ? (
                <div className='fixed z-[97] top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-start bg-black bg-opacity-70 p-2'>
                    <div className='w-full flex justify-end pb-2'>
                        <div
                            onClick={openEnquiry}
                            className='bg-light w-[48px] h-[48px] flex justify-center items-center rounded-md'
                        >
                            <IoClose
                                color='black'
                                size={30}
                            />
                        </div>
                    </div>
                    <ContactCardProject className='z-[98]' project={project} dictionary={dictionary} lang={lang} agent={agent}/>
                </div>
            ):null}
            <div className='sm:hidden z-[50] w-full bg-maincolor bg-opacity-80 flex justify-between bottom-0 fixed p-1 border-t-[1px] border-forth rounded-t-md'>
                <div className='w-[45px] min-w-[45px] h-[45px] mr-1'>
                    <a href={company.phoneUrl} className='w-full h-full flex flex-col justify-center bg-red-600  items-center rounded-md shadow-sm drop-shadow-md' target="_blank">
                        <MdPhoneIphone
                            color={tailwindConfig.theme.extend.colors.light}
                            size={30}
                            className=''
                        />
                    </a>
                </div>
                <div className='w-[45px] min-w-[45px] h-[45px] mr-1'>
                    <a href={company.lineUrl} className='w-full h-full flex flex-col justify-center bg-gradient-to-r from-[#32CD32] to-[#32CD32] items-center rounded-md shadow-sm drop-shadow-md' target="_blank">
                        <FaLine
                            color={tailwindConfig.theme.extend.colors.light}
                            size={30}
                            className=''
                        />
                    </a>
                </div>
                <div onClick={openEnquiry} className='w-full flex justify-center items-center bg-third text-light font-bold rounded-md shadow-[0_8px_30px_rgb(0,0,0,0.12)] mx-[1px]'>
                    <span>{dictionary.message}</span>
                </div>
            </div>
        </>
    )
}

export default ProjectContact